export const addTranslation = text => ({
    type: 'ADD_TRANSLATION',
    text
})